var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54852 4.98437L10.4295 8.86545C10.5235 8.95934 10.5235 9.11584 10.4295 9.24104L9.74106 9.92961C9.61587 10.0235 9.45932 10.0235 9.36543 9.92961L8.70815 9.27233L5.51566 6.04854L1.63459 9.92961C1.54069 10.0235 1.3842 10.0235 1.259 9.92961L0.570423 9.24104C0.476526 9.11584 0.476526 8.95934 0.570423 8.86545L4.45149 4.98437L0.570423 1.13459C0.476526 1.04069 0.476526 0.884197 0.570423 0.759001L1.259 0.0704228C1.3842 -0.0234743 1.54069 -0.0234743 1.63459 0.0704228L5.51566 3.9515L9.36543 0.0704228C9.45932 -0.0234743 9.61587 -0.0234743 9.74106 0.0704228L10.4295 0.759001C10.5235 0.884197 10.5235 1.04069 10.4295 1.13459L9.77231 1.79187L6.54852 4.98437Z"
  })));
};
export default __webpack_public_path__ + "assets/e33d306ea425645323c9c0d298de99a2.svg";
export { SvgX as ReactComponent };


// WEBPACK FOOTER //
// ./components/inputs/icons/X.svg